const React = require('react');
const CartOrderedDish = require('./cart-ordered-dish.jsx');
import ConfirmDialog from '../../mui/dialog/confirm-dialog';
import { SiglePrivTypes } from '../../../helper/const.js';
const helper = require('../../../helper/dish-helper');
const formatPrice = require('../../../helper/common-helper').formatPrice;

import FormattedMessage from '@/intl/formatted-message';
import shoppingCartMessages from '../../../intl/messages/shopping-cart';
import { isSingleDishWithoutProps } from '../../../helper/dish-helper';

require('./expand-cart.scss');

module.exports = React.createClass({
  displayName: 'ExpandCart',
  propTypes: {
    dishesCount: React.PropTypes.number.isRequired,
    onCartIconTap: React.PropTypes.func.isRequired,
    onOrderBtnTap: React.PropTypes.func.isRequired,
    onClearBtnTap: React.PropTypes.func.isRequired,
    orderedDishes: React.PropTypes.array,
    getCartOrderedListHeight: React.PropTypes.func,
    isMember: React.PropTypes.bool,
    ableAddPriceDiscount: React.PropTypes.bool,
  },
  getInitialState() {
    return {
      confirmDialogVisible: false,
      expandCartZindex: { zIndex: 10 },
    };
  },
  componentDidMount() {
    this.getOuterStyle();
  },
  componentWillReceiveProps(nextProps) {},
  componentDidUpdate(prevProps, prevState) {
    const { orderedDishes: orderedDishesNew } = this.props;
    const { orderedDishes } = prevProps;
    if (orderedDishes !== orderedDishesNew) {
      this.getOuterStyle();
    }
  },
  getOuterStyle() {
    const { getCartOrderedListHeight } = this.props;
    const expandCartMain = document.querySelector('.expand-cart-main');
    let cartOrderedListHeight = 0;
    if (expandCartMain) {
      cartOrderedListHeight = expandCartMain.offsetHeight;
    }
    if (getCartOrderedListHeight) {
      getCartOrderedListHeight(cartOrderedListHeight);
    }
  },
  renderHDLPrivInfo(dishData) {
    const { singleMarketingInfos = [] } = dishData || {};
    const memberPrice = formatPrice(helper.getDishMemberPrice(dishData));
    const formateSingleMarketingInfos =
      singleMarketingInfos &&
      singleMarketingInfos.length > 0 &&
      singleMarketingInfos.map(info => {
        let reduceTotal = 0;
        switch (info.type) {
          case SiglePrivTypes.DISCOUNT:
            reduceTotal =
              dishData.isMember && memberPrice > 0
                ? memberPrice * (1 - info.value * 0.1)
                : dishData.marketPrice * (1 - info.value * 0.1);
            break;
          case SiglePrivTypes.REDUCE:
            reduceTotal = info.value;
            break;
          default:
            break;
        }

        return { ...info, reduceTotal };
      });

    const { reduceTotal } = []
      .concat(formateSingleMarketingInfos)
      .sort((a, b) => b.reduceTotal - a.reduceTotal)[0];

    return {
      reduceTotal,
      key: dishData.key,
    };
  },
  toggleClearConfirmDlg(visible) {
    this.setState({
      confirmDialogVisible: visible,
      expandCartZindex: visible ? { zIndex: 11 } : { zIndex: 10 },
    });
  },
  expandDishFunc() {
    this.getOuterStyle();
  },
  buildOrderedElements(orderedDishes, onOrderBtnTap) {
    function divideDishes(dishes) {
      return [].concat.apply(
        [],
        dishes.map(dish => {
          if (isSingleDishWithoutProps(dish)) {
            return [Object.assign({}, dish, { key: `${dish.id}` })];
          }
          return dish.order.map((dishOrder, idx) =>
            Object.assign(
              {},
              dish,
              { key: `${dish.id}-${idx}` },
              { order: [Object.assign({}, dishOrder)] }
            )
          );
        })
      );
    }
    const dividedDishes = divideDishes(orderedDishes);
    const { showHandleInput } = this.props;
    let tmp = [];
    dividedDishes.map(item => {
      const reduceprice = this.renderHDLPrivInfo(item).reduceTotal || 0;
      if (reduceprice !== 0) {
        tmp.push({ reduceprice, key: item.key });
      }
      return tmp;
    });
    let max = (tmp[0] && tmp[0].reduceprice) || 0;
    let arr = [];
    let count = 0;
    for (let i = 0; i < tmp.length; i++) {
      if (tmp.length === 1) {
        max = tmp[0];
        arr = tmp[0];
      } else {
        if (typeof max === 'object') {
          if (max && max.reduceprice < (tmp[i + 1] && tmp[i + 1].reduceprice)) {
            max = tmp[i + 1];
            arr = tmp[i + 1];
            count = i + 1;
          } else {
            max = max;
            arr = max;
            count = i;
          }
          // max = max && max.reduceprice < (tmp[i + 1] && tmp[i + 1].reduceprice) ? tmp[i + 1] : max;
          // arr = max && max.reduceprice < (tmp[i + 1] && tmp[i + 1].reduceprice) ? tmp[i + 1] : max;
        } else {
          if (max < (tmp[i + 1] && tmp[i + 1].reduceprice)) {
            max = tmp[i + 1];
            arr = tmp[i + 1];
            count = i + 1;
          } else {
            max = tmp[i];
            arr = tmp[i];
            count = i;
          }
          // max = max < (tmp[i + 1] && tmp[i + 1].reduceprice) ? tmp[i + 1] : max;
          // arr = max < (tmp[i + 1] && tmp[i + 1].reduceprice) ? tmp[i + 1] : max;
        }
      }
    }
    return (
      <div className="cart-ordered-list cart-ordered-list-new">
        {this.props.isHDL
          ? dividedDishes.map(dish => (
              <CartOrderedDish
                key={dish.key}
                dish={dish}
                onOrderBtnTap={onOrderBtnTap}
                showHandleInput={showHandleInput}
                expandDishFunc={this.expandDishFunc}
                isdiscount={
                  max !== 0 && `${dish.key}` == max.key ? true : false
                }
                reduceprice={
                  typeof max != 'number'
                    ? formatPrice(max.reduceprice)
                    : formatPrice(max)
                }
                isHDL={this.props.isHDL}
                showItemsReduce={this.props.showItemsReduce}
                isMember={this.props.isMember}
                ableAddPriceDiscount={this.props.ableAddPriceDiscount}
              />
            ))
          : dividedDishes.map(dish => (
              <CartOrderedDish
                key={dish.key}
                dish={dish}
                onOrderBtnTap={onOrderBtnTap}
                showHandleInput={showHandleInput}
                expandDishFunc={this.expandDishFunc}
                isMember={this.props.isMember}
                ableAddPriceDiscount={this.props.ableAddPriceDiscount}
              />
            ))}
      </div>
    );
  },
  onClearBtnTap() {
    const { onClearBtnTap } = this.props;
    sessionStorage.removeItem('reducePrice');
    sessionStorage.removeItem('reducePriceNum');
    sessionStorage.removeItem('reducePriceKey');
    onClearBtnTap();
    setTimeout(() => {
      this.getOuterStyle();
    }, 0);
  },
  render() {
    const {
      dishesCount,
      onOrderBtnTap,
      onCartIconTap,
      orderedDishes,
    } = this.props;
    const { expandCartZindex } = this.state;
    const orderedElements = this.buildOrderedElements(
      orderedDishes,
      onOrderBtnTap
    );
    return (
      <div className="expand-cart" style={expandCartZindex}>
        <div
          className="expand-cart-close"
          onTouchTap={evt => {
            evt.preventDefault();
            onCartIconTap(dishesCount);
          }}
        />
        <div className="expand-cart-main">
          <div className="expand-cart-header of">
            <strong className="expand-cart-title">
              <FormattedMessage {...shoppingCartMessages.title} />
            </strong>
            <button
              className="expand-cart-clear"
              onTouchTap={() => this.toggleClearConfirmDlg(true)}
            >
              <FormattedMessage {...shoppingCartMessages.clear} />
            </button>
          </div>
          {orderedElements}
        </div>
        {this.state.confirmDialogVisible === true && (
          <ConfirmDialog
            onConfirm={this.onClearBtnTap}
            onCancel={() => this.toggleClearConfirmDlg(false)}
          >
            <p>
              <FormattedMessage {...shoppingCartMessages.clearConfirmed} />
            </p>
          </ConfirmDialog>
        )}
      </div>
    );
  },
});



// WEBPACK FOOTER //
// ./src/component/dish-menu/cart/expand-cart.jsx